module.exports = __webpack_public_path__ + "img/Navraj.23f3a1f8.png";